import React from 'react';
import { Wrapper, AdditionalDataWrapper, AdditionalData, AdditionalDataItem, AdditionalDataTitle } from './styled';
import { Celebration } from './Celebration';
import { QuietnessMeter } from './QuietnessMeter';
import { SmallText } from 'ds/components/typography';

import PublicIcon from 'assets/svg/quiet-street/building.svg';
import CommercialIcon from 'assets/svg/quiet-street/shops.svg';
import MixedUseIcon from 'assets/svg/quiet-street/building-shop.svg';
import HasTransitIcon from 'assets/svg/quiet-street/bus.svg';
import NoTransitIcon from 'assets/svg/quiet-street/no-bus.svg';
import { useLocale } from 'locale';
import { WithContentSlotSidePaddingContainer } from 'ds/components/Layout';
import { UseType, IQuietStreet } from 'store/state/selectors/insights/summaryTypes';



const useTypeToIcon: Record<UseType, React.ReactNode> = {
  [UseType.Public]: <PublicIcon />,
  [UseType.Commercial]: <CommercialIcon />,
  [UseType.Mixed]: <MixedUseIcon />,
};

export const QuietStreetSummary: React.FC<{ data: IQuietStreet }> = ({ data }) => {
  const { t } = useLocale();

  return (
    <WithContentSlotSidePaddingContainer>
      <Wrapper>
        {data.celebration && data.celebration.type ? <Celebration generalText={data.generalText} {...data.celebration} /> : null}
        <QuietnessMeter value={data.bin} />
        <AdditionalDataWrapper>
          <AdditionalDataTitle>{t('widget.quietStreet.additionalData')}</AdditionalDataTitle>
          <AdditionalData>
            <AdditionalDataItem>
              {data.transit.hasTransit ? <HasTransitIcon /> : <NoTransitIcon />}
              <SmallText>{data.transit.text}</SmallText>
            </AdditionalDataItem>
            <AdditionalDataItem>
              {useTypeToIcon[data.useType.type]}
              <SmallText>{data.useType.text}</SmallText>
            </AdditionalDataItem>
          </AdditionalData>
        </AdditionalDataWrapper>
      </Wrapper>
    </WithContentSlotSidePaddingContainer>
  );
};
